module.exports = __webpack_public_path__ + "img/video.ac3eec78.png";